module.exports = __webpack_public_path__ + "static/media/like-scavenger-disabled.f16bda50.svg";